import { render, staticRenderFns } from "./sysset.vue?vue&type=template&id=04b09d68&scoped=true&"
import script from "./sysset.vue?vue&type=script&lang=js&"
export * from "./sysset.vue?vue&type=script&lang=js&"
import style0 from "./sysset.vue?vue&type=style&index=0&id=04b09d68&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b09d68",
  null
  
)

export default component.exports